import { useMutation, useQueryClient } from "@tanstack/react-query";
import TutorialJourneyProfilesService from "../../../services/TutorialJourneyProfilesService";
import { TUTORIAL_PROFILES_QUERY_KEY } from "../journey/TutorialJourneysList";
import {
  ITutorialJourneyProfileDto,
  ITutorialJourneysViewModel,
  TutorialJourneyProfileDto,
} from "@growth-machine-llc/stridist-api-client";

export function useCreateTutorialJourneyProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: TutorialJourneyProfilesService.createTutorialJourneyProfile,
    onSuccess: (newProfile) => {
      queryClient.setQueryData<ITutorialJourneysViewModel>(
        [TUTORIAL_PROFILES_QUERY_KEY],
        (oldData) => {
          const previousData = oldData || { profiles: [], journeys: [] };
          return {
            ...previousData,
            profiles: [
              newProfile as unknown as TutorialJourneyProfileDto,
              ...previousData.profiles,
            ],
          };
        },
      );
      queryClient.invalidateQueries({
        queryKey: [TUTORIAL_PROFILES_QUERY_KEY],
      });
    },
  });
}
